module.exports = __webpack_public_path__ + "img/11.7d3698d2.jpg";